import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from './cn.js';
export function Tablo({ className, ...rest }) {
    return (_jsx("div", { className: "border-fume-200 dark:border-fume-800 dark:bg-fume-900 w-full overflow-x-auto rounded-xl border bg-white shadow-sm", children: _jsx("table", { className: cn('w-full min-w-[640px] text-sm', className), ...rest }) }));
}
export function TabloBaslik(props) {
    return (_jsx("thead", { className: "bg-fume-50 text-fume-500 dark:bg-fume-800/40 dark:text-fume-400 text-xs uppercase tracking-wider", ...props }));
}
export function TabloSatir({ className, ...rest }) {
    return (_jsx("tr", { className: cn('border-fume-100 hover:bg-fume-50/60 dark:border-fume-800 dark:hover:bg-fume-800/40 border-t transition-colors', className), ...rest }));
}
export function TabloBaslikHucresi({ className, ...rest }) {
    return _jsx("th", { className: cn('px-4 py-3 text-left font-medium', className), ...rest });
}
export function TabloHucre({ className, ...rest }) {
    return (_jsx("td", { className: cn('text-fume-800 dark:text-fume-100 px-4 py-3 align-middle', className), ...rest }));
}
export function TabloGovde(props) {
    return _jsx("tbody", { ...props });
}
//# sourceMappingURL=tablo.js.map